var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({width: `${_vm.width}px`, height: `${_vm.height}px`})},[(_vm.animationUrl)?_c('iframe',{attrs:{"src":_vm.animationUrl,"frameborder":"0","width":"100%","height":"100%","allow":"autoplay","title":"Details Loading Animation"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }